import { FormattedMessage } from 'react-intl'
import { useRouter } from 'solito/router'

import CloseIcon from 'app/assets/icons/close-icon.svg'
import Button from 'app/components/base/Button'
import IconButton from 'app/components/base/IconButton'
import Stack from 'app/components/base/Stack'
import Text from 'app/components/base/Text'
import { menuItems } from 'app/utils/constants/menu.constants'

interface AlertShippingRulesNotSetupProps {
  onClose: () => void
  variant: 'bulk' | 'ebay'
}

const AlertShippingRulesNotSetup: RFC<AlertShippingRulesNotSetupProps> = ({
  onClose,
  variant
}) => {
  const { push } = useRouter()

  const isBulk = variant === 'bulk'

  return (
    <Stack
      direction="column"
      spacing={1}
      sx={{ position: 'relative', mt: 0.5 }}
    >
      <Stack direction="row" sx={{ mr: '16px !important' }}>
        <Stack direction="column" sx={{ mt: 1 }}>
          <Text variant="body1">
            {isBulk ? (
              <FormattedMessage defaultMessage="You need to setup shipping & return rules to use bulk upload" />
            ) : (
              <FormattedMessage defaultMessage="You need to setup shipping & return rules to connect your store" />
            )}
          </Text>

          <Button
            variant="contained"
            size="small"
            onClick={() => {
              push(menuItems.shipping.link)

              onClose()
            }}
            sx={{ width: 270, mt: 2 }}
          >
            <FormattedMessage defaultMessage="Go to Shipping & Return Rules" />
          </Button>
        </Stack>
      </Stack>

      <IconButton
        onClick={onClose}
        sx={{ position: 'absolute', right: '-10px', top: '-16px' }}
      >
        <CloseIcon />
      </IconButton>
    </Stack>
  )
}

export default AlertShippingRulesNotSetup
